import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../enums/user-role.enum';

export const roleGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const user = authService.currentUserValue;

  // Roles permitidas para esta rota (definidas no app.routes.ts)
  const allowedRoles = route.data['roles'] as Array<UserRole>;

  if (user && user.role && allowedRoles.includes(user.role)) {
    return true;
  }

  if (user) {
    // Se logado mas sem acesso, redireciona para sua home padrão
    if (user.role === UserRole.ADMIN) {
      router.navigate(['/admin']);
    } else if (user.role === UserRole.EVENT_ADMIN) {
      router.navigate(['/organizer']);
    } else {
      router.navigate(['/portal']);
    }
  } else {
    // Se não logado, vai para login
    router.navigate(['/auth/login']);
  }

  return false;
};
